import { digitalData } from "../../Types/Types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getDigital } from "../middleware/digitalMiddleware";

interface digitalDataState {
  loading: boolean;
  error: string | null;
  dataDigital: digitalData[] | null;
}

const initialState: digitalDataState = {
  loading: false,
  error: null,
  dataDigital: null,
};

const digitalSlice = createSlice({
  name: "digital",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getDigital.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getDigital.fulfilled,
        (state, action: PayloadAction<digitalData[]>) => {
          state.loading = false;
          state.dataDigital = action.payload;
        }
      )
      .addCase(getDigital.rejected, (state, action: PayloadAction<any>) => {
        state.error = action.payload;
      });
  },
});

export default digitalSlice.reducer;
